import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    namaSubKelompok: Yup.string().required(
      "Masukan nama sub kelompok anggaran"
    ),
    idKelompok: Yup.string().required("Pilih kelompok anggaran"),
  });
